import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IOperator, IProiect } from '../../proiecte.interface';
import { helper } from 'src/environments/helper';
import { ProiecteService } from '../../proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, map } from 'rxjs';
import { IAddOperatorPayload, IOperatorForm } from './operatori-proiect.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import Swal from 'sweetalert2';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-operatori-proiect',
    templateUrl: './operatori-proiect.component.html',
    styleUrls: ['./operatori-proiect.component.scss']
})
export class OperatoriProiectComponent {
    @Input() proiect!: IProiect;
    @Input() operatoriTeren!: Generic[];;
    @Output() proiectChanged: EventEmitter<void> = new EventEmitter();

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;
    showEditField = false;
    passedProiectId!: number;
    operatoriProiect!: IOperator[];
    form!: FormGroup;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    constructor(
        private proiecteService: ProiecteService,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        public permissionsService: PermissionsService,
    ) { }

    ngOnChanges(): void {
        this.passedProiectId = this.proiect.id_proiect;
        this.operatoriProiect = this.proiect.operatori;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            id_operator: new FormControl(-1, [Validators.required, Validators.min(0)]),
        })
    }

    submitForm() {
        this.isLoading = true;

        const {
            id_operator,
        } = this.form.value as IOperatorForm;
        const payload: IAddOperatorPayload = {
            id_user: id_operator,
        };

        this.proiecteService
            .addOperator(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Operator teren adăugat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.closeEditField();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    toggleEditField() {
        this.showEditField = !this.showEditField;
    }

    closeEditField() {
        this.showEditField = false;
    }

    removeOperator(id_operator: number) {
        this.isLoading = true;

        this.proiecteService
            .removeOperator(id_operator)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Operator șters cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.closeEditField();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    setPrimaryOperator(id_operator: number) {
        this.isLoading = true;

        this.proiecteService
            .setPrimaryOperator(id_operator)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Operatorul este responsabil primar!',
                        this.successIcon
                    ).then(() => {
                        this.proiectChanged.emit();
                        this.closeEditField();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
